<div [formGroup]="group" [attr.class]="styleForm" [class.icon]="icon">
    <label *ngIf="label" [attr.for]="controlName">{{ label }}</label>
    <div [class.has-icon]="icon">
        <i *ngIf="icon" [attr.class]="icon"></i>
        <textarea
            class="textarea-field field"
            [formControlName]="controlName"
            [attr.placeholder]="placeholder"
            [maxlength]="maxlength"
            (blur)='onBlur($event)'
            (keyup)="onChange($event); onKeyup($event)"
            (keypress)="testChar($event)"></textarea>
    </div>
</div>
